import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body {
    body {
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;
    }
    #root {
      position: relative;
      width: 100%;
      height: 100%;
    }
    #root > section {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
`;
